import React, { useContext } from "react";
import Can from "../can/Can";
import { AppContext } from "../../App";
import { serviceBalance } from "../../rbac-consts";

import { default as SuperAdminServiceBalancesContainer } from "./superAdmin/ServiceBalancesContainer";
import { default as AdminServiceBalancesContainer } from "./admin/ServiceBalancesContainer";

const ServiceBalancesWrapper = () => {
  const { user } = useContext(AppContext);

  return (
    <>
      <Can
        role={user.roles}
        perform={serviceBalance.SUPER_ADMIN}
        yes={() => (
          <SuperAdminServiceBalancesContainer />
        )}
      />
      <Can
        role={user.roles}
        perform={serviceBalance.ADMIN}
        yes={() => (
          <AdminServiceBalancesContainer />
        )}
      />
    </>
  );
};

export default ServiceBalancesWrapper;